import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-temp-report',
  templateUrl: './new-temp-report.component.html',
  styleUrls: ['./new-temp-report.component.scss']
})
export class NewTempReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/device-report/tempreture-report/new-temp-report/new-temp-report.component.ts